function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.575 21.723h-11.637l-1.995-10.227h-2.83v-1h3.654l1.995 10.227h10.813z",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.362 19.22889h-10.583v-1h10.583a.17669.17669 0 0 0 .165-.11328l1.59668-4.13282a.1778.1778 0 0 0 -.165-.24121h-13.22948v-1h13.2295a1.17854 1.17854 0 0 1 1.09863 1.60157l-1.59668 4.13285a1.1847 1.1847 0 0 1 -1.09865.75289z",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.00264 24.28944a1.78956 1.78956 0 1 1 1.79-1.79 1.79151 1.79151 0 0 1 -1.79 1.79zm0-2.57911a.78956.78956 0 1 0 .79.78907.78938.78938 0 0 0 -.79-.78907z",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.6042 24.28944a1.78956 1.78956 0 1 1 1.79-1.79 1.79151 1.79151 0 0 1 -1.79 1.79zm0-2.57911a.78956.78956 0 1 0 .79.78907.78938.78938 0 0 0 -.79-.78907z",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.e3b7e3cbfe9a74845160d61b21877f48.svg";
export { ForwardRef as ReactComponent };